(function () {
  window.parseDeliveryDaysRange = function (str) {
    if (!str) return null;
    const value = str.toLowerCase().trim();
    if (!value) return null;

    let min;
    let max;
    const rangeMatch = value.match(/(\d+)\s*[–-]\s*(\d+)/);
    if (rangeMatch) {
      min = parseInt(rangeMatch[1], 10);
      max = parseInt(rangeMatch[2], 10);
    } else {
      const singleMatch = value.match(/(\d+)/);
      if (!singleMatch) return null;
      min = max = parseInt(singleMatch[1], 10);
    }

    let multiplier = 1;
    if (/werktag|werkdag|hverdag|business\s*day|ouvrabl/.test(value)) {
      multiplier = 1.4;
    } else if (/monat|maand|month|mois|måned/.test(value)) {
      multiplier = 30;
    } else if (/week|weken|woche|semain|uger?/.test(value)) {
      multiplier = 7;
    }

    return {
      minDays: Math.ceil(min * multiplier),
      maxDays: Math.ceil(max * multiplier),
    };
  };

  const variants = new Map();
  const inputs = {
    _delivery_time: 'delivery-time-input',
    _delivery_days_min: 'delivery-days-min-input',
    _delivery_days_max: 'delivery-days-max-input',
  };

  const cleanText = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

  const fromText = (deliveryTime, deliveryRaw = deliveryTime) => {
    const range = window.parseDeliveryDaysRange(deliveryRaw || deliveryTime);
    return {
      _delivery_time: cleanText(deliveryTime),
      _delivery_days_min: range ? String(range.minDays) : '',
      _delivery_days_max: range ? String(range.maxDays) : '',
    };
  };

  const assign = (properties, deliveryTime, deliveryRaw = deliveryTime) => {
    return Object.assign(properties, fromText(deliveryTime, deliveryRaw));
  };

  const register = (entries) => {
    entries.forEach((entry) => {
      if (entry?.variantId == null || entry.requiresShipping === false) return;
      variants.set(String(entry.variantId), fromText(entry.deliveryTime, entry.deliveryRaw));
    });
  };

  const forVariant = (variantId) => variants.get(String(variantId ?? '')) || null;

  const assignVariant = (properties, variantId) => {
    const delivery = forVariant(variantId);
    return delivery ? Object.assign(properties, delivery) : properties;
  };

  const applyToForm = (form, variantId) => {
    if (!form) return false;
    const selectedVariantId = variantId ?? form.elements.namedItem('id')?.value;
    const delivery = forVariant(selectedVariantId);
    if (!delivery) return false;

    Object.entries(inputs).forEach(([property, className]) => {
      let input = form.querySelector(`.${className}`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${property}]`;
        input.classList.add(className);
        form.appendChild(input);
      }
      input.value = delivery[property];
    });

    return true;
  };

  const enrichItems = (items) => {
    items.forEach((item) => {
      item.properties ||= {};
      assignVariant(item.properties, item.id);
    });
    return items;
  };

  window.deliveryProperties = {
    register,
    fromText,
    assign,
    forVariant,
    assignVariant,
    applyToForm,
    enrichItems,
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    window.deliveryProperties.applyToForm(form);
  }, true);

  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const delivery = forVariant(event.formData.get('id'));
    if (!delivery) return;
    Object.entries(delivery).forEach(([key, value]) => {
      event.formData.set(`properties[${key}]`, value);
    });
  }, true);

  class DeliveryProperties extends HTMLElement {
    constructor() {
      super();
      this._onVariantChangedListener = this._onVariantChanged.bind(this);
    }

    connectedCallback() {
      const data = this.querySelector('script[type="application/json"]');
      if (data) {
        try {
          window.deliveryProperties.register(JSON.parse(data.textContent || '[]'));
        } catch (error) {
          console.error('[delivery-properties] Invalid variant data', error);
        }
      }

      const formId = this.getAttribute('form');
      this._productForm = formId
        ? document.forms[formId] || document.getElementById(formId)
        : this.closest('form');
      this._productForm?.addEventListener('variant:change', this._onVariantChangedListener);
      window.deliveryProperties.applyToForm(this._productForm);
      queueMicrotask(() => window.deliveryProperties.applyToForm(this._productForm));
    }

    disconnectedCallback() {
      this._productForm?.removeEventListener('variant:change', this._onVariantChangedListener);
    }

    _onVariantChanged(event) {
      window.deliveryProperties.applyToForm(this._productForm, event.detail.variant?.id);
    }
  }

  if (!window.customElements.get('delivery-properties')) {
    window.customElements.define('delivery-properties', DeliveryProperties);
  }
})();
